import { NgModule } from '@angular/core';
import { Routes, RouterModule, Route } from '@angular/router';
import { GiftListComponent } from './gift-list/gift-list.component';
import { WinTumblerComponent } from './win-tumbler/win-tumbler.component';

const winTumblerRoute: Route = {
  path: 'win-tumbler',
  component: WinTumblerComponent
}

const defaultRoute: Route = {
  path: '',
  component: GiftListComponent
}

const routes: Routes = [ winTumblerRoute, defaultRoute ];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
